export const enum NileSliderEvents {
  NILE_INIT = "nile-init",
  NILE_CHANGE = "nile-change",
  NILE_CHANGE_END = "nile-change-end",
  NILE_BUTTON_FIRST_CHANGE = "nile-button-first-change",
  NILE_BUTTON_LAST_CHANGE =  "nile-button-last-change",
  NILE_BUTTON_FIRST_CHANGE_END = "nile-button-first-change-end",
  NILE_BUTTON_LAST_CHANGE_END =  "nile-button-last-change-end",
  NILE_DESTROY = "nile-destroy", 
}